// components/DataTable/DataTableCell.jsx

import React from "react";
import {
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";

import {
  formatNumber,
  truncateText,
  findDropdownItem
} from "./utils";

/**
 * @typedef {Object} DataTableCellProps
 * @property {Object} row
 * @property {Object} column
 * @property {string} locale
 */

/**
 * @param {DataTableCellProps} props
 */
function DataTableCell({
  row,
  column,
  locale
}) {
  const value = row[column.field];

  /*
   * STRING
   */
  if (column.type === "string") {
    const text =
      value === null || value === undefined
        ? ""
        : String(value);

    const displayText = truncateText(
      text,
      column.maxLength
    );

    if (
      column.maxLength &&
      text.length > column.maxLength
    ) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`tooltip-${column.field}`}>
              {text}
            </Tooltip>
          }
        >
          <span
            style={{
              cursor: "help"
            }}
          >
            {displayText}
          </span>
        </OverlayTrigger>
      );
    }

    return <span>{displayText}</span>;
  }

  /*
   * NUMBER
   */
  if (column.type === "number") {
    return (
      <span>
        {formatNumber(value, locale)}
      </span>
    );
  }

  /*
   * BOOL
   */
  if (column.type === "bool") {
    return (
      <div className="datatable-checkbox-cell">
        <input
          type="checkbox"
          checked={value === true}
          readOnly
          disabled
          aria-label={column.title}
        />
      </div>
    );
  }

  /*
   * DROPDOWN
   */
  if (column.type === "dropdown") {
    const item = findDropdownItem(
      column.dataSource,
      column,
      value
    );

    if (!item) {
      return <span />;
    }

    return (
      <span>
        {item[column.textField] !== null &&
        item[column.textField] !== undefined
          ? String(item[column.textField])
          : ""}
      </span>
    );
  }

  return <span />;
}

export default React.memo(DataTableCell);